import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import WhatsAppButton from "@/components/layout/WhatsAppButton";
import ScrollToTop from "@/components/layout/ScrollToTop";
import PreFooterCTA from "@/components/layout/PreFooterCTA";
import BackToTopButton from "@/components/layout/BackToTopButton";
import SplashPage from "@/pages/SplashPage";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import TreatmentsPage from "@/pages/TreatmentsPage";
import HospitalsPage from "@/pages/HospitalsPage";
import GuidePage from "@/pages/GuidePage";
import ContactPage from "@/pages/ContactPage";
import FAQPage from "@/pages/FAQPage";
import BlogPage from "@/pages/BlogPage";
import BlogPostPage from "@/pages/BlogPostPage";
import LandingPage from "@/pages/LandingPage";
import HospitalPartnerPage from "@/pages/HospitalPartnerPage";
import HealthcarePage from "@/pages/HealthcarePage";
import PartnerLogin from "@/pages/PartnerLogin";
import PartnerDashboard from "@/pages/PartnerDashboard";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PatientRegister from "@/pages/PatientRegister";
import PatientLogin from "@/pages/PatientLogin";
import PatientDashboard from "@/pages/PatientDashboard";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <LanguageProvider>
          <BrowserRouter>
            <ScrollToTop />
            <div className="min-h-screen flex flex-col">
              <Navbar />
              <main className="flex-1">
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/splash" element={<SplashPage />} />
                  <Route path="/patients" element={<HomePage />} />
                  <Route path="/partners" element={<HospitalPartnerPage />} />
                  <Route path="/healthcare/:category" element={<HealthcarePage />} />
                  <Route path="/partner/login" element={<PartnerLogin />} />
                  <Route path="/partner" element={<PartnerDashboard />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/treatments" element={<TreatmentsPage />} />
                  <Route path="/hospitals" element={<HospitalsPage />} />
                  <Route path="/guide" element={<GuidePage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/faq" element={<FAQPage />} />
                  <Route path="/blog" element={<BlogPage />} />
                  <Route path="/blog/:slug" element={<BlogPostPage />} />
                  <Route path="/for/international" element={<LandingPage />} />
                  <Route path="/admin/login" element={<AdminLogin />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/patient/register" element={<PatientRegister />} />
                  <Route path="/patient/login" element={<PatientLogin />} />
                  <Route path="/patient" element={<PatientDashboard />} />
                </Routes>
              </main>
              <PreFooterCTA />
              <Footer />
              <WhatsAppButton />
              <BackToTopButton />
            </div>
            <Toaster position="top-right" richColors />
          </BrowserRouter>
        </LanguageProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
